<template>
    <div class="all-view">

        <div class="all-header">
            <p class="all-subtitle">{{ i18n.descubre }}</p>
        </div>

        <div class="all-cards">
            <router-link
                v-for="s in sitios"
                :key="s.id"
                :to="s.url"
                class="text-decoration-none"
            >
                <div
                    class="restaurant-card"
                    :style="cardStyle(s)"
                >
                    <div class="card-overlay"></div>
                    <div class="card-content">
                        <span class="card-name">{{ s.nombre }}</span>
                    </div>
                </div>
            </router-link>

            <div v-if="sitios.length === 0" class="loading-placeholder">
                <IconLoader2 size="36" class="icon-rotate" style="color: rgba(255,255,255,0.4)" />
            </div>
        </div>

    </div>
</template>

<script>
import axios from "axios";
import {API_URL} from "@/store/sitio";
import {getI18n} from "@/locales/locales";
import IconLoader2 from "@/partials/Icons/IconLoader2";

export default {
    name: 'AllView',

    components: {IconLoader2},

    data() {
        return {
            sitios: []
        };
    },

    computed: {
        i18n() {
            return getI18n();
        },
    },

    methods: {
        cardStyle(s) {
            if (s.foto_url) {
                return {
                    backgroundImage: `url(${s.foto_url})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                };
            }
            return {
                backgroundColor: s.color_fondo || '#002844',
            };
        },
    },

    created() {
        axios.get(API_URL + '/sitios', {
            params: { locale: localStorage.locale || 'es' }
        }).then(resp => {
            this.sitios = resp.data;
        });
    }
}
</script>

<style scoped>
.all-view {
    max-width: 550px;
    margin: 0 auto;
    padding: 0 16px 32px;
}

.all-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0 28px;
}

.all-subtitle {
    color: rgba(255, 255, 255, 0.55);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    margin: 0;
}

.all-cards {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.restaurant-card {
    position: relative;
    border-radius: 12px;
    height: 90px;
    overflow: hidden;
    transition: transform 0.18s ease, box-shadow 0.18s ease;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
}

.restaurant-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}

.card-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 100%);
}

.card-content {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 0 20px;
}

.card-name {
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.02em;
}

.loading-placeholder {
    display: flex;
    justify-content: center;
    padding: 40px 0;
}
</style>
